module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-greek-ext-500-normal.woff2?6fb9cffb1d3e72bf92931a793383673a";